var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pinterest_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.353 0C6.226.001 2.438 4.567 2.438 9.546c0 2.309 1.29 5.19 3.356 6.103.589.265.511-.059 1.018-1.998a.46.46 0 0 0-.11-.452c-2.954-3.415-.577-10.438 6.23-10.438 9.85 0 8.01 13.63 1.714 13.63-1.623 0-2.832-1.273-2.45-2.85.464-1.877 1.372-3.895 1.372-5.248 0-3.41-5.081-2.904-5.081 1.614 0 1.396.494 2.339.494 2.339s-1.635 6.604-1.938 7.838c-.514 2.089.07 5.47.12 5.761.031.16.211.211.312.08.161-.212 2.137-3.03 2.691-5.069.201-.742 1.028-3.753 1.028-3.753.545.983 2.116 1.807 3.79 1.807 4.979 0 8.577-4.377 8.577-9.808C23.544 3.896 19.088 0 13.353 0Z",
    fill: "#89969A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pinterest_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
};
export default SvgPinterest;